import {useSelector} from "react-redux";
import {RootState} from "@/store";
import BookingInsightPieLayoutResult
  , {
  PieChartData,
  PieLayoutSummaryData, PieLayoutTableData
} from "@/pages/Report/BookingInsightPieLayoutResult";
import {currencyFormat} from "@/utils";
import {pieColors} from "@/pages/Report/constant";

const bookingMethodsMapping = [
  'Walk In', // booking_method_id 1
  'Call/Chat', // booking_method_id 2
  'Customer App' // booking_method_id 3
]

const BookingMethodResult = () => {
  const bookingMethod = useSelector((state: RootState) => state.bookingInsight.state.bookingMethod)
  const details = bookingMethod?.details ?? []
  const summaryData = {
    totalHours: bookingMethod?.total_hours ?? 0,
    totalValues: bookingMethod?.total_revenue ?? 0
  } as PieLayoutSummaryData

  const tableData = {
    headers: ['METHODS', 'HOURS', 'VALUES'],
    data: bookingMethod?.details?.map(d => {
      const method = bookingMethodsMapping[d.booking_method_id - 1]
      return [method, d.total_hours, currencyFormat(d.total_revenue)]
    })
  } as PieLayoutTableData

  const pieChartData = {
    labels: bookingMethodsMapping,
    datasets: [
      {
        label: 'Total Hours',
        data: details.map(d => d.total_hours),
        borderColor: pieColors,
        backgroundColor: pieColors,
        borderWidth: 1
      }
    ]
  } as PieChartData

  return (
    <>
      {
        bookingMethod && <BookingInsightPieLayoutResult
          pieChartData={pieChartData}
          tableData={tableData}
          summaryData={summaryData} />
      }
    </>
  );
};

export default BookingMethodResult;